import IqosSeaSide from '@containers/IQOSUniverse/articles/IqosSeaSide/IqosSeaSide';
export default IqosSeaSide;
